module.exports = __webpack_public_path__ + "static/media/logistic-partners.c42d3169.svg";